







import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CvSectionDateItemStoreEdit from '@/store/modules/cvSectionDateItemEdit';
import EditContainer from '@/containers/cv-section-date-item/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionDateItemStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_date_id, id } = params;
  await store.dispatch(
    CvSectionDateItemStoreEdit.GetCvSectionDateItem.namespaced({
      params: { cv_id, cv_section_date_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionDateItemStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionDateItem']),
  },
});
